/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aroma_Sampling_NewInputs */

const vi_aroma_sampling_new = /** @type {(inputs: Aroma_Sampling_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thêm lần lấy hương`)
};

/**

* @param {Aroma_Sampling_NewInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const aroma_sampling_new = /** @type {((inputs?: Aroma_Sampling_NewInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aroma_Sampling_NewInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_aroma_sampling_new(inputs)
});